/** @jsx jsx */
import { jsx } from "theme-ui"
import AppStoreBadges from "./AppStoreBadges"
import Logo from '../images/banl-logo-circle.png'
import Text from "./text"
import Button from "./button"
import Socials from "./socials"
import { ExternalLink } from "./link"


function FooterNav() {
    return (
        <div sx={{
            backgroundColor: "secondary",
            px: 5,
            py: 4,
            flex: 0,
        }}>
            <div sx={{display: [undefined, undefined, 'block', 'flex'], justifyContent: 'space-between'}}>
                <div sx={{flex: 0.3, display: 'flex', mb: [4, 4, 4, 1,],}}>
                    <div sx={{display: 'flex'}}>
                        <img width="107" height="106" src={Logo} sx={{mr: 4}} />
                        <div>
                            <ExternalLink ssx={{color: 'primary',}} href="https://businessandartsnl.com/">www.businessandartsnl.com</ExternalLink>
                            <ExternalLink ssx={{color: 'primary',}} href="mailto:info@businessandartsnl.com">info@businessandartsnl.com</ExternalLink>
                        </div>
                    </div>
                </div>

                <div sx={{mb: [4, 4, 4, 1],}}>
                    <Text light>Download the mobile app</Text>
                    <AppStoreBadges />
                </div>

                <div style={{flex: 0.3, minWidth: '300px'}}>
                    <div sx={{mb: 5}}>
                        <Text marginBelow light>Sign up to receive our weekly Spotlight on Partnerships and stay up to date.</Text>
                        <Button secondary onClick={() => window.open('https://businessandartsnl.com/blog/')}>Newsletter Signup</Button>
                    </div>

                    <div>
                        <Socials />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterNav